import { Component, OnInit, inject } from '@angular/core';
import { NavigationService, StorageService } from '../../services';
import { OUTLAW_COOKIES } from '../../consts';

@Component({
  selector: 'ol-payment-cancel',
  template: '<p>redirecting...</p>',
})
export class PaymentCancelComponent implements OnInit {
  private storageService = inject(StorageService);
  private navigationService = inject(NavigationService);

  ngOnInit(): void {
    const returnUrl = this.storageService.useOnce(OUTLAW_COOKIES.return_url);
    if (returnUrl) {
      this.navigationService.openOnSamePage(returnUrl);
      return;
    }
    this.navigationService.goToFeed();
    return;
  }
}
